import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { getErrorsArr } from "containers/Errors/reducer";

import Errors from "components/Errors/Errors";

class ErrorsContainer extends React.PureComponent {
  render() {
    return <Errors {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = (state) => ({
  errors: getErrorsArr(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ErrorsContainer);
